import { AutoCloseable1l5p57f9lp7kv as AutoCloseable } from '../../../kotlin-kotlin-stdlib/kotlin/AutoCloseableJs.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SourceClass;
function Source() {
  if (SourceClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Source', VOID, VOID, [AutoCloseable()]);
    SourceClass = $;
  }
  return SourceClass;
}
//region block: exports
export {
  Source as Source1shr0ps16u4p4,
};
//endregion

//# sourceMappingURL=Source.mjs.map
